export const columnsA = function () {
    return [
		{
		  prop: "energyType",
		  label: "能源类型",
		  minWidth: 30,
		},
        {
          prop: "rateRegion",
          label: "费率地区",
          minWidth: 30,
        },
        {
          prop: "nature",
          label: "使用性质",
          minWidth: 50,
        },
        {
          prop: "carType",
          label: "车辆种类",
          minWidth: 50,
        },
        {
          prop: "useYears",
          label: "使用年数",
          minWidth: 50,
        },
        {
          prop: "basicPremium",
          label: "标准费用(元)",
          minWidth: 30,
        },
        {
          prop: "rate",
          label: "费率(%)",
          minWidth: 30,
        },
        {
          prop: "handle",
          label: "操作",
          minWidth: 50,
        },

    ]
}

export const columnsB = function () {
    return [
		{
		  prop: "energyType",
		  label: "能源类型",
		  minWidth: 200,
		},
        {
          prop: "rateRegion",
          label: "费率地区",
          minWidth: 200,
        },
        {
          prop: "nature",
          label: "使用性质",
          minWidth: 200,
        },
        {
          prop: "carType",
          label: "车辆种类",
          minWidth: 200,
        },
        {
          prop: "coverage",
          label: "保额(万元)",
          minWidth: 200,
        },
        {
          prop: "standardStyle",
          label: "标准费用(元)",
          minWidth: 200,
        },
        {
          prop: "handle",
          label: "操作",
          minWidth: 100,
        },
    ]
}

export const columnsC = function () {
    return [
		{
		  prop: "energyType",
		  label: "能源类型",
		  minWidth: 200,
		},
       {
         prop: "rateRegion",
         label: "费率地区",
         minWidth: 200,
       },
       {
         prop: "nature",
         label: "使用性质",
         minWidth: 200,
       },
       {
         prop: "carType",
         label: "车辆种类",
         minWidth: 200,
       },
       {
         prop: "driverRate",
         label: "驾驶人费率(%)",
         minWidth: 200,
       },
       {
         prop: "passengerRate",
         label: "乘客费率(%)",
         minWidth: 200,
       },
       {
         prop: "handle",
         label: "操作",
         minWidth: 100,
       },
    ]
}

export const columnsD = function () {
    return [
		{
		  prop: "province_name",
		  label: "地区",
		  minWidth: 200,
		},
       {
         prop: "claim_occurrence",
         label: "营运性质",
         minWidth: 200,
       },
       {
         prop: "type",
         label: "出险次数",
         minWidth: 200,
       },
       {
         prop: "tonnage",
         label: "车辆种类",
         minWidth: 200,
       },
       {
         prop: "rate",
         label: "费率基数",
         minWidth: 200,
       },
    ]
}

export const columnsE = function () {
    return [
		{
		  prop: "province_name",
		  label: "地区",
		  minWidth: 200,
		},
       {
         prop: "tonnage",
         label: "费率基数",
         minWidth: 200,
       },
    ]
}

// 搜索
export const searchFormOption = function() {
  return [
	   {
		 prop: "energyType",
		 label: "能源类型",
		 type: "select",
		 placeholder: "请选择能源类型",
		 width: "20%",
		 options: this.energyType
	   },
	   {
		 prop: "rateRegion",
		 label: "费率地区",
		 type: "select",
		 placeholder: "请选择地区",
		 width: "20%",
		 options: this.regionOptions
	   },
	   {
		 prop: "nature",
		 label: "使用性质",
		 type: "select",
		 placeholder: "请选择使用性质",
		 width: "20%",
		 options: this.nature
		}
  ]
}

// 表单相关
export const rateFormOption = function() {
  return [
	   {
		 prop: "energyType",
		 label: "能源类型",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.energyType
	   },
	   {
		 prop: "rateRegion",
		 label: "费率地区",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.regionOptions
	   },
	   {
		 prop: "nature",
		 label: "使用性质",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.nature,
	   },
	   {
		 prop: "carType",
		 label: "车辆种类",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.carType
	   },
	   {
		 prop: "useYears",
		 label: "使用年数",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: [{'value':'4年以上'},{'value':'3-4年'},{'value':'2-3年'},{'value':'2年以下'}]
	   },
	   {
		 prop: "basicPremium",
		 label: "基础保费",
		 type: "input",
		 placeholder: 0,
		 width: "20%",
		 templateNote:'元'
	   },
	   {
		 prop: "rate",
		 label: "费率",
		 type: "input",
		 placeholder: 0,
		 width: "20%",
		 templateNote:'%'
	   },
  ]
}
// 三者费率
export const threeFormOption = function() {
  return [
	   {
		 prop: "energyType",
		 label: "能源类型",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.energyType
	   },
	   {
		 prop: "rateRegion",
		 label: "费率地区",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.regionOptions
	   },
	   {
		 prop: "nature",
		 label: "使用性质",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.nature,
	   },
	   {
		 prop: "carType",
		 label: "车辆种类",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.carType
	   },
	   {
		 prop: "coverage",
		 label: "保额",
		 type: "input",
		 placeholder: '0',
		 width: "20%",
		 templateNote:'万元'
	   },
	   {
		 prop: "standardStyle",
		 label: "标准费用",
		 type: "input",
		 placeholder: '0',
		 width: "20%",
		 templateNote:'元'
	   },
  ]
}
// 驾乘费率
export const drivingFormOption = function() {
  return [
	   {
		 prop: "energyType",
		 label: "能源类型",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.energyType
	   },
	   {
		 prop: "rateRegion",
		 label: "费率地区",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.regionOptions
	   },
	   {
		 prop: "nature",
		 label: "使用性质",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.nature,
	   },
	   {
		 prop: "carType",
		 label: "车辆种类",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.carType
	   },
	   {
		 prop: "driverRate",
		 label: "驾驶人费率",
		 type: "input",
		 placeholder: '0',
		 width: "20%",
		 templateNote:'%'
	   },
	   {
		 prop: "passengerRate",
		 label: "乘客费率",
		 type: "input",
		 placeholder: '0',
		 width: "20%",
		 templateNote:'%'
	   },
  ]
}

// 强制险费率
export const compulsoryFormOption = function() {
  return [
	   {
		 prop: "province_name",
		 label: "地区",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.regionOptions
	   },
	   {
		 prop: "claim_occurrence",
		 label: "运营性质",
		 type: "input",
		 placeholder: "营运/非营运",
		 width: "20%",
	   },
	   {
		 prop: "type",
		 label: "出险次数",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.typeOptions,
	   },
	   {
		 prop: "tonnage",
		 label: "车辆种类",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.carType
	   },
	   {
		 prop: "rate",
		 label: "费率基数",
		 type: "input",
		 placeholder: '0',
		 width: "20%",
	   },
  ]
}

// 车船税费率
export const vesselsFormOption = function() {
  return [
	   {
		 prop: "province_name",
		 label: "地区",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.regionOptions
	   },
	   {
		 prop: "tonnage",
		 label: "费率基数",
		 type: "input",
		 placeholder: "0",
		 width: "20%",
	   },
  ]
}
/**
 * 校验相关 
 */
export const rulesOne = function(self) {
  return {
    rateRegion: [
      { required: true, message: '请选择费率地区', trigger: ['change', 'blur']}
    ],
	energyType: [
	  { required: true, message: '请选择能源类型', trigger: ['change', 'blur']}
	],
	nature: [
	  { required: true, message: '请选择使用性质', trigger: ['change', 'blur']}
	],
	carType: [
	  { required: true, message: '请选择车辆种类', trigger: ['change', 'blur']}
	],
	useYears: [
	  { required: true, message: '请选择使用年数', trigger: ['change', 'blur']}
	],
	basicPremium: [
	  { required: true, message: '请填写基础保费', trigger: ['change', 'blur']}
	],
	rate: [
	  { required: true, message: '请填写费率', trigger: ['change', 'blur']}
	],
  }
}
export const rulesTwo = function(self) {
  return {
    rateRegion: [
      { required: true, message: '请选择费率地区', trigger: ['change', 'blur']}
    ],
	energyType: [
	  { required: true, message: '请选择能源类型', trigger: ['change', 'blur']}
	],
	nature: [
	  { required: true, message: '请选择使用性质', trigger: ['change', 'blur']}
	],
	carType: [
	  { required: true, message: '请选择车辆种类', trigger: ['change', 'blur']}
	],
	coverage: [
	  { required: true, message: '请填写保额', trigger: ['change', 'blur']}
	],
	standardStyle: [
	  { required: true, message: '请填写标准费用', trigger: ['change', 'blur']}
	],
  }
}
export const rulesThree = function(self) {
  return {
    rateRegion: [
      { required: true, message: '请选择费率地区', trigger: ['change', 'blur']}
    ],
	energyType: [
	  { required: true, message: '请选择能源类型', trigger: ['change', 'blur']}
	],
	nature: [
	  { required: true, message: '请选择使用性质', trigger: ['change', 'blur']}
	],
	carType: [
	  { required: true, message: '请选择车辆种类', trigger: ['change', 'blur']}
	],
	driverRate: [
	  { required: true, message: '请填写驾驶人费率', trigger: ['change', 'blur']}
	],
	passengerRate: [
	  { required: true, message: '请填写乘客费率', trigger: ['change', 'blur']}
	],
  }
}
export const rulesFour = function(self) {
  return {
    province_name: [
      { required: true, message: '请选择费率地区', trigger: ['change', 'blur']}
    ],
	claim_occurrence: [
	  { required: true, message: '请选择营运性质', trigger: ['change', 'blur']}
	],
	type: [
	  { required: true, message: '请选择出险次数', trigger: ['change', 'blur']}
	],
	tonnage: [
	  { required: true, message: '请选择车辆种类', trigger: ['change', 'blur']}
	],
	rate: [
	  { required: true, message: '请填写费率基数', trigger: ['change', 'blur']}
	],
  }
}
export const rulesFive = function(self) {
  return {
    province_name: [
      { required: true, message: '请选择费率地区', trigger: ['change', 'blur']}
    ],
	tonnage: [
	  { required: true, message: '请填写费率基数', trigger: ['change', 'blur']}
	],
  }
}

export default {}